const arMessages= {
  /* 01.General */

   "main.name": "الاسم",
  "main.sentiment": "المشاعر",
  "main.urgency": "الإلحاح",
  "main.language": "اللغة",
  "main.agent": "الوكيل",
  "main.property_name": "اسم المنشأة",
  "main.booking_number": "رقم الحجز",
  "main.check_out": "تسجيل المغادرة",
  "main.check_in": "تسجيل الوصول",
  "main.adults": "البالغون",
  "main.corporate_code": "الرمز المؤسسي",
  "main.group_code": "رمز المجموعة",
  "main.promo_code": "الرمز الترويجي",
  "main.ai_response": "استجابة الذكاء الاصطناعي",
  "main.template_response": "استجابة القالب",
  "main.converttoticket": "تحويل إلى تذكرة",
  "main.switch_property": "تبديل المنشأة",
  "main.Group_id": "معرف المجموعة",
  "main.integration_id": "معرف التكامل",
  "main.submit": "إرسال",
  "main.cancel": "إلغاء",
  "main.select_template": "اختر قالبًا",
  "main.rooms": "الغرف",
  "main.rates": "الأسعار",

  //footer
  "footer.knowledge": "المعرفة",
  "footer.home": "الرئيسية",
  "footer.help": "المساعدة",

  //ticket
  "ticket.thank_you": "شكرًا لك على إرسال النموذج",
  "ticket.ticket": "تذكرة",
  "ticket.details": "يرجى ملء النموذج الذي يوضح تفاصيل التذكرة.",
  "ticket.select_category": "اختر الفئة",
  "ticket.category": "الفئة",
  "ticket.title": "العنوان",
  "ticket.notes": "ملاحظات",
  "ticket.status": "الحالة",
  "ticket.assigned_to": "معين إلى",
  "ticket.submit_form": "إرسال النموذج",

  
  "main.total": "الإجمالي",
  "main.pastetooutlook": "لصق إلى Outlook",
  "main.children": "الأطفال",
  "main.promocode": "الرمز الترويجي/رمز الشركة/رمز المجموعة",
  "main.exact_match_only": "تطابق تام فقط",
  "main.search": "بحث",
  "main.no_rate_match": "لا توجد أسعار تطابق اختيارك. يرجى تعديل البحث والمحاولة مرة أخرى.",
  "main.translate_to": "ترجمة إلى",
  "main.regenerate": "إعادة إنشاء",
  "main.copy_text": "نسخ النص",
  "main.additional_instructions": "تعليمات إضافية",

  "faq.helpcenter": "مركز المساعدة",
  "faq.reply.email.sabre.question": "كيف يمكنني الرد على بريد إلكتروني باستخدام أتمتة البريد الإلكتروني لـ Aven Hospitality Concierge؟",
  "faq.reply.email.sabre.answer": "افتح البريد الإلكتروني وقم بتشغيل إضافة Aven Hospitality. يمكنك الاختيار بين ثلاثة خيارات: استخدام قالب محدد مسبقًا، أو إنشاء رد بالذكاء الاصطناعي، أو تحويل البريد الإلكتروني إلى تذكرة. اختر الخيار الأنسب للاستفسار، وراجع الرد، وأجرِ أي تعديلات إذا لزم الأمر، ثم أرسله مباشرة من Outlook.",

  "faq.rates.availability.question": "كيف يمكنني إضافة الأسعار والتوافر وتفاصيل الغرف إلى ردي؟",
  "faq.rates.availability.answer": "استخدم ميزة + Rates لإدخال تفاصيل الضيف مثل التواريخ وعدد الضيوف، وسيقوم Concierge بإضافة التوافر والأسعار الدقيقة إلى ردك. يمكنك أيضًا استخدام + Rooms لإضافة أوصاف الغرف والصور، مما يساعد الضيوف على فهم خياراتهم بشكل أفضل.",

  "faq.different.language.question": "ماذا أفعل إذا كان البريد الإلكتروني بلغة مختلفة؟",
  "faq.different.language.answer": "يسمح لك Aven Hospitality Concierge بترجمة رسائل البريد الإلكتروني الواردة إلى لغتك المفضلة، مما يجعلها أسهل للفهم. يمكنك بعد ذلك إنشاء أو تعديل الرد وترجمته مرة أخرى إلى لغة الضيف قبل الإرسال.",

  "faq.pin.addin.question": "كيف أتأكد من أن الإضافة متاحة دائمًا في Outlook؟",
  "faq.pin.addin.answer": "لإبقاء Aven Hospitality Concierge ظاهرًا دائمًا، قم بتثبيت الإضافة في Outlook. يضمن ذلك فتحها تلقائيًا مع كل بريد إلكتروني، مما يسمح لك بإنشاء الردود بسرعة وإضافة الأسعار أو تفاصيل الغرف دون الحاجة إلى إعادة فتحها كل مرة.",

  "faq.knowledge.hub.question": "ما هو خيار البحث في مركز المعرفة؟",
  "faq.knowledge.hub.answer": "يسمح لك البحث في مركز المعرفة بالعثور بسرعة على معلومات خاصة بالمنشأة مباشرة داخل Outlook. يمكنك البحث عن تفاصيل مثل الغرف والمرافق والسياسات أو الأسئلة الشائعة وإدراج المعلومات الدقيقة بسهولة في ردود البريد الإلكتروني.",

  "faq.reply.email.myma.question": "كيف يمكنني الرد على بريد إلكتروني باستخدام Myma؟",
  "faq.reply.email.myma.answer": "افتح البريد الإلكتروني وقم بتشغيل إضافة Myma. يمكنك الاختيار بين ثلاثة خيارات: استخدام قالب محدد مسبقًا، أو إنشاء رد بالذكاء الاصطناعي، أو تحويل البريد الإلكتروني إلى تذكرة. اختر الخيار الأنسب للاستفسار، وراجع الرد، وأجرِ التعديلات إذا لزم الأمر، ثم أرسله مباشرة من Outlook.",

  "faq.room.details.question": "كيف يمكنني إضافة تفاصيل الغرفة إلى ردي؟",
  "faq.room.details.answer": "استخدم + Rooms لإضافة أوصاف الغرف والصور، مما يساعد الضيوف على فهم خياراتهم بشكل أفضل.",

  "faq.myma.different.language.question": "ماذا أفعل إذا كان البريد الإلكتروني بلغة مختلفة؟",
  "faq.myma.different.language.answer": "يسمح لك Myma بترجمة رسائل البريد الإلكتروني الواردة إلى لغتك المفضلة، مما يجعلها أسهل للفهم. يمكنك بعد ذلك إنشاء أو تعديل الرد وترجمته مرة أخرى إلى لغة الضيف قبل الإرسال.",

  "faq.myma.pin.addin.question": "كيف أتأكد من أن الإضافة متاحة دائمًا في Outlook؟",
  "faq.myma.pin.addin.answer": "لإبقاء Myma ظاهرًا دائمًا، قم بتثبيت الإضافة في Outlook. يضمن ذلك فتحها تلقائيًا مع كل بريد إلكتروني، مما يسمح لك بإنشاء الردود بسرعة وإضافة الأسعار أو تفاصيل الغرف دون الحاجة إلى إعادة فتحها كل مرة."


};
export default arMessages;